import React from "react";
import { Box, styled, BoxProps } from "@material-ui/core";
import { CaptionedText } from "./CaptionedText";

const BoxCell = styled(Box)(({ theme }) => ({
  flex: "1 0 32%",
  whiteSpace: "nowrap",
  paddingRight: theme.spacing(1),
  paddingBottom: theme.spacing(2.5),
}));

export const AgreementTariff: React.FC<
  {
    rates: {
      caption: string;
      text: string;
    }[];
    charge: string | null;
  } & BoxProps
> = ({ rates, charge, ...props }) => (
  <Box display="flex" flexDirection="row" flexWrap="wrap" {...props}>
    <>
      {rates.map((r, key) => (
        <BoxCell key={`${r.caption}${key}`} data-testid="Agreement--UnitRate">
          <CaptionedText {...r} />
        </BoxCell>
      ))}
    </>
    <BoxCell data-testid="Agreement--StandingCharge">
      {charge != null ? (
        <CaptionedText caption="Standing charge" text={charge} />
      ) : null}
    </BoxCell>
  </Box>
);
